
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/bestearpluglawyers",
      function () {
        return require("private-next-pages/bestearpluglawyers/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/bestearpluglawyers"])
      });
    }
  